<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cGboZV/tc-custom/9781504037556.jpg?1728851932522" alt="This image is the cover for the book Bad Desire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bad Desire
      </h1>
      <p class="bookDescription body article font2">
        <b>An innocent teenage girl sparks a psychopath’s obsessive desire in this chilling tale of suspense and serial murder.</b><br/><br/> Beautiful high school cheerleader Sheila Bonner has a new dress for the prom and a football-player boyfriend who’s wild about her—but she can’t resist another clandestine rendezvous with her hometown’s handsome mayor, Henry Lee Slater. Despite her grandmother’s warnings not to go off alone with him, Sheila is flattered by Slater’s attentions. And when a senseless act of violence rocks her world, he is there to comfort her.<br/>  <br/> Unbeknownst to his wife and constituents, Slater has silently stalked the young blonde since she came to town seven years ago as an orphan. Now he’s taking steps to possess Sheila and satisfy every one of his dark desires. But how long can he keep his indiscretions hidden from the adoring public, his dutiful wife, and the cagey local police chief without spiraling further into deception and cold-blooded murder?<br/>  <br/> Replete with unforgettable, vividly drawn characters and more reversals and twists than an Alfred Hitchcock film, <i>Bad Desire</i> is a novel of “forbidden love and serial murder that thrills from intriguing start to chilling finish” (<i>Publishers Weekly</i>).<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gary Devon
      </h2>
      
      <p class="authorDescription body article">Gary Devon (1941&ndash;2007) grew up on the banks of the Ohio River in Indiana, a part of the country to which he later returned with his wife and sons. After graduating from the University of Evansville, he won a writing contest sponsored by the&#160;<I>New Yorker</I>&#160;and was awarded a fellowship to the Iowa Writers&rsquo; Workshop, where he studied with Kurt Vonnegut and Jos&eacute; Donoso. His first novel,&#160;<I>Lost</I>, was nominated for the Mystery Writers of America&rsquo;s Edgar Award. He wrote two other novels,&#160;<I>Bad Desire</I>&#160;and&#160;<I>Wedding Night</I>.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5f7befb0